import CLIENT_STRUCT from '../../entities/client';

export const CALCULATED_CLIENT_STRUCT = {
  ...CLIENT_STRUCT,
  INVESTS: 'calculated_invests',
  MEETINGS: 'calculated_meetings',
  POSITION: 'calculated_position',
  INSTITUTION: 'calculated_institution',
};
